
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { MobileRaiseProjection } from "@/store/mobile-raise-templates/types";
import { sortBy } from "lodash";
import Title from "./Title.vue";

@Component({
	components: {
		"raise-title": Title
	}
})
export default class QuickSelect extends Vue {
	@Prop() raises: MobileRaiseProjection[];

	get sortedRaises() {
		return sortBy(this.raises, ["gridSetSlot"]);
	}

	get raiseItemClass() {
		return ["quick-item", this.raises.length === 9 ? "width-third" : "width-half"];
	}
}
